export interface LogicalTerminalDisplayLabelInput {
    readonly name: string | null;
    readonly processor_name: string;
    readonly processor_mid: string;
    readonly processor_tid: string;
}

export interface TerminalDeviceDisplayLabelInput {
    readonly name: string | null;
    readonly processor_name: string;
    readonly processor_mid: string;
    readonly processor_tid: string;
    readonly processor_device_id: string;
}

function getTrimmedNameOrNull(name: string | null): string | null {
    const trimmedName: string = name?.trim() ?? '';
    return trimmedName.length > 0 ? trimmedName : null;
}

export function getLogicalTerminalDisplayLabel(
    input: LogicalTerminalDisplayLabelInput
): string {
    return (
        getTrimmedNameOrNull(input.name) ??
        `${input.processor_name} / ${input.processor_mid} / ${input.processor_tid}`
    );
}

export function getTerminalDeviceDisplayLabel(
    input: TerminalDeviceDisplayLabelInput
): string {
    return (
        getTrimmedNameOrNull(input.name) ??
        `${input.processor_name} / ${input.processor_mid} / ${input.processor_tid} / ${input.processor_device_id}`
    );
}

